import { Address } from 'viem';

export enum MarketplaceOrderStatus {
  Create,
  Update,
  Cancel,
  Buy,
}

export interface OrderDto {
  orderId: number;
  seller: Address;
  amount: string;
  pricePerOne: string;
  timestamp: string;
  status: MarketplaceOrderStatus;
}

export enum OrderUpdateActionType {
  create = 'create',
  update = 'update',
  cancel = 'cancel',
  buy = 'buy',
  fulfilled = 'fulfilled_by_offer',
}

export interface OrderUpdatedDto {
  id: number;
  buyer: string;
  seller: string;
  amountNative: string;
  action: OrderUpdateActionType;
  amountsNft: number;
  totalFeeAmount: string;
  date: string;
  pricePerOne: string;
  amountSale: string;
  txHash: string;
}
